import { isPortalEnabled, portalLogoutUrl, redirectToPortalLogin } from '@/auth-portal'

const Login = () => import('@/views/Login.vue')
const ResetPassword = () => import('@/views/ResetPassword.vue')
const ForgotPassword = () => import('@/views/ForgottenPassword.vue')

const Dashboard = () => import('@/views/Dashboard.vue')

const NewslettersList = () => import('@/views/newsletters/List.vue')
const NewslettersView = () => import('@/views/newsletters/View.vue')
const NewslettersDraft = () => import('@/views/newsletters/Draft.vue')

const ArticlesList = () => import('@/views/articles/List.vue')
const ArticlesCreate = () => import('@/views/articles/Create.vue')
const ArticlesDraft = () => import('@/views/articles/Draft.vue')
const ArticlesEdit = () => import('@/views/articles/Edit.vue')
const ArticlesView = () => import('@/views/articles/View.vue')
const ArticlesRepublish = () => import('@/views/articles/Republish.vue')

// const ContentTypesList = () => import('@/views/content-types/List.vue')
// const ContentTypesEdit = () => import('@/views/content-types/Edit.vue')
// const ContentTypesCreate = () => import('@/views/content-types/Create.vue')

const CompaniesList = () => import('@/views/companies/List.vue')
const CompaniesView = () => import('@/views/companies/View.vue')
const CompaniesCreate = () => import('@/views/companies/Create.vue')
const CompaniesCreateManually = () => import('@/views/companies/CreateManually.vue')
const CompaniesCreateFromIsin = () => import('@/views/companies/CreateFromIsin.vue')

const AlertsView = () => import('@/views/alerts/View.vue')
const AlertsEdit = () => import('@/views/alerts/Edit.vue')
const AlertsCreate = () => import('@/views/alerts/Create.vue')

const PackageList = () => import('@/views/packages/List.vue')
const PackageView = () => import('@/views/packages/View.vue')
const PackageCreate = () => import('@/views/packages/Create.vue')

const AccountList = () => import('@/views/accounts/List.vue')
const AccountView = () => import('@/views/accounts/View.vue')
const AccountCreate = () => import('@/views/accounts/Create.vue')

const SubscriptionList = () => import('@/views/subscriptions/List.vue')
const SubscriptionView = () => import('@/views/subscriptions/View.vue')
const SubscriptionCreate = () => import('@/views/subscriptions/Create.vue')

const ChannelsList = () => import('@/views/channels/List.vue')
const ChannelsView = () => import('@/views/channels/View.vue')
const ChannelsAnalysts = () => import('@/views/channels/Analysts.vue')
const ChannelsCreate = () => import('@/views/channels/Create.vue')

const UsersList = () => import('@/views/users/List.vue')
const UsersView = () => import('@/views/users/View.vue')
const UsersCreate = () => import('@/views/users/Create.vue')

const AnalystsList = () => import('@/views/analysts/List.vue')
const AnalystsCreate = () => import('@/views/analysts/Create.vue')
const AnalystsView = () => import('@/views/analysts/View.vue')

const Search = () => import('@/views/search/View.vue')

const KeenDatasets = () => import('@/views/keen/Datasets.vue')

const EquitiesList = () => import('@/views/equities/List.vue')
const EquitiesEdit = () => import('@/views/equities/Edit.vue')
const EquitiesCreate = () => import('@/views/equities/Create.vue')

const Redirect = () => import('@/views/Redirect.vue')
const Sso = () => import('@/views/Sso.vue')
const Ghost = () => import('@/views/Ghost.vue')

const LatestLayoutView = () => import('@/views/latest-layout/View.vue')
const EventsView = () => import('@/views/events/View.vue')

const CountriesList = () => import('@/views/countries/List.vue')
const CountriesEdit = () => import('@/views/countries/Edit.vue')

const IndicesList = () => import('@/views/indices/List.vue')
const IndexCreate = () => import('@/views/indices/Create.vue')
const IndexEdit = () => import('@/views/indices/Edit.vue')

export default [
  {
    name: 'redirect',
    path: '/',
    component: Redirect,
    // component: {
    //   mounted () {
    //     if (this.$login.is()) {
    //       return this.$router.replace('/dashboard.vue')
    //     }
    //     window.location.href = `${process.env.VUE_APP_TELLIMER_URL}signin#enterprise`
    //   },
    //   template: '<div/>',
    // },
  },
  {
    path: '/sso',
    name: 'sso',
    component: Sso,
    // component: {
    //   mounted () {
    //     this.$login.setToken(this.$route.query.token)

    //     this.$http.get('/user.vue')
    //         .then((response) => {
    //           this.$login.setUser(response.data)
    //           this.$router.replace({name: 'dashboard'})
    //         })
    //   },
    //   template: '<div/>',
    // },
  },
  {
    path: '/ghost',
    name: 'ghost',
    component: {
      mounted() {
        // @ts-ignore
        this.$login.setToken(this.$route.query.token)
        // @ts-ignore
        this.$http.get('/user').then((response) => {
          // @ts-ignore
          this.$login.setUser(response.data)
          // @ts-ignore
          this.$nextTick(() => {
            // @ts-ignore
            this.$router.replace({ name: 'dashboard' })
          })
        })
      },
      template: '<div/>',
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'login',
    path: '/login',
    component: Login,
    beforeEnter: (to, from, next) => {
      if (isPortalEnabled()) {
        redirectToPortalLogin('/dashboard')
        return next(false)
      }
      return next()
    },
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'logout',
    path: '/logout',
    component: {
      template: `<div/>`,
      beforeRouteEnter(to, from, next) {
        next((vm) => {
          vm.$login.logout()
          if (isPortalEnabled()) {
            window.location.assign(portalLogoutUrl())
            return
          }
          return vm.$router.go('/login')
        })
      },
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'newsletters',
    path: '/newsletters',
    component: NewslettersList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'newsletters.create',
    path: '/newsletters/create',
    component: NewslettersDraft,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'newsletters.draft',
    path: '/newsletters/draft/:draftId',
    component: NewslettersDraft,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'newsletters.view',
    path: '/newsletters/:newsletterId',
    component: NewslettersView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'articles',
    path: '/articles',
    component: ArticlesList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'articles.create',
    path: '/articles/create',
    component: ArticlesCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/articles/draft/:draftId',
    name: 'articles.draft',
    component: ArticlesDraft,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/articles/:articleId',
    name: 'articles.view',
    component: ArticlesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/articles/:articleId/republish',
    name: 'articles.republish',
    component: ArticlesRepublish,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/articles/:articleId/edit',
    name: 'articles.edit',
    component: ArticlesEdit,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   name: 'content-types',
  //   path: '/content-types',
  //   component: ContentTypesList,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   name: 'content-types.create',
  //   path: '/content-types/create',
  //   component: ContentTypesCreate,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   name: 'content-types.edit',
  //   path: '/content-types/:contentTypeId',
  //   component: ContentTypesEdit,
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    name: 'companies',
    path: '/companies',
    component: CompaniesList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'companies.create',
    path: '/companies/create',
    component: CompaniesCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'companies.create-manually',
    path: '/companies/create-manually',
    component: CompaniesCreateManually,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'companies.create-from-isin',
    path: '/companies/create-from-isin',
    component: CompaniesCreateFromIsin,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'companies.create-from-suggestion',
    path: '/companies/suggestion/:suggestionId',
    component: CompaniesCreateManually,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'companies.view',
    path: '/companies/:companyId',
    component: CompaniesView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'accounts',
    path: '/accounts',
    component: AccountList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'accounts.create',
    path: '/accounts/create',
    component: AccountCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'accounts.view',
    path: '/accounts/:accountId',
    component: AccountView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'subscriptions',
    path: '/subscriptions',
    component: SubscriptionList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'subscriptions.create',
    path: '/subscriptions/create',
    component: SubscriptionCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'subscriptions.view',
    path: '/subscriptions/:subscriptionId',
    component: SubscriptionView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'packages',
    path: '/packages',
    component: PackageList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'packages.create',
    path: '/packages/create',
    component: PackageCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'packages.edit',
    path: '/packages/:packageId',
    component: PackageView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'channels',
    path: '/channels',
    component: ChannelsList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'channels.create',
    path: '/channels/create',
    component: ChannelsCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'channels.view',
    path: '/channels/:channelId',
    component: ChannelsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'channels.analysts',
    path: '/channels/:channelId/analysts',
    component: ChannelsAnalysts,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'analysts.create',
    path: '/analysts/create',
    component: AnalystsCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'analysts.view',
    path: '/analysts/:analystId',
    component: AnalystsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'alerts.create',
    path: '/alerts/create/:id?/:type?',
    component: AlertsCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'alerts.edit',
    path: '/alerts/:alertId/edit',
    component: AlertsEdit,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'alerts.view',
    path: '/alerts/:alertId',
    component: AlertsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'reset-password',
    path: '/reset-password/:token/:email',
    component: ResetPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'forgot-password',
    path: '/forgot-password',
    component: ForgotPassword,
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'analysts',
    path: '/analysts',
    component: AnalystsList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'users',
    path: '/users',
    component: UsersList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'users.create',
    path: '/users/create',
    component: UsersCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'users.view',
    path: '/users/:userId',
    component: UsersView,
    meta: {
      requiresAuth: true,
    },
  },
  // Countries
  {
    name: 'countries',
    path: '/countries',
    component: CountriesList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'countries.edit',
    path: '/countries/:slug',
    component: CountriesEdit,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'keen.datasets',
    path: '/keen/datasets',
    component: KeenDatasets,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'search',
    path: '/search',
    component: Search,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'equities',
    path: '/equities',
    component: EquitiesList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'equities.create',
    path: '/equities/create',
    component: EquitiesCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'equities.edit',
    path: '/equities/:id',
    component: EquitiesEdit,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'latest-layout',
    path: '/latest-layout',
    component: LatestLayoutView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'events',
    path: '/events',
    component: EventsView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'indices',
    path: '/indices',
    component: IndicesList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'indices.create',
    path: '/indices/create',
    component: IndexCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'indices.edit',
    path: '/indices/:slug',
    component: IndexEdit,
    meta: {
      requiresAuth: true,
    },
  },
]
